import React, { useEffect, useState, useCallback } from "react";
import { Link } from "@quintype/components";
import { useSelector } from "react-redux";
import get from "lodash/get";

import { AdContainer } from "../../ads";
import { getCollection, filterStory, filterCollection } from "../../helper/api";
import StoryCard3 from "../../molecules/story-card3";
import MobileStoryCard1 from "../../molecules/story-card1/mobile-story-card1";
import CardImage from "../../atoms/cardimage";

import "./mobile-collection-with-ad.m.css";
import CollectionWidgetMobDesk from "../collection-widget-mob-desk";

const collectionWidgetHardcode = `<style>   /* Default iframe style for desktop */   .responsive-iframe {     width: 100%;     height: 60px; /* Default height for desktop */     border: none;     overflow: hidden;   }    /* Adjust height for mobile devices */   @media (max-width: 767px) {     .responsive-iframe {       height: 85px; /* Adjusted height for mobile */     }   } </style>  <iframe style="overflow: hidden;"      class="responsive-iframe"      src="https://tpml-sites.s3.ap-south-1.amazonaws.com/mh-widgets.html"      allowfullscreen> </iframe>`;

const MobileCollection = ({ collection }) => {
  const isCollectionWidgetMobDesk = collection?.["associated-metadata"]?.layout == "CollectionWidgetMobDesk";
  const isCollectionWidgetMobDeskWithContent = collection?.["associated-metadata"]?.content !== "";
  const isWidgetAdded = isCollectionWidgetMobDesk && isCollectionWidgetMobDeskWithContent;

  if (!(collection && collection.items)) {
    return null;
  }
  if (isWidgetAdded) {
    return <CollectionWidgetMobDesk collection={collection} />;
  }
  const stories = filterStory(collection);
  const collectionTemplate = get(collection, ["associated-metadata", "layout"], "");

  if (!stories.length) return null;

  const subashithaCollection = filterCollection(collection)[0];
  const subashithaStory = subashithaCollection && subashithaCollection.items[0] && subashithaCollection.items[0].story;

  const qtState = useSelector((state) => get(state, ["qt"], {}));

  const [brandspotStories, setBrandspotStories] = useState([]);
  const useBrandspotStories = get(collection, ["metadata", "brand-spot"], false);

  useEffect(() => {
    if (["true", "True", "t", "T"].includes(useBrandspotStories)) {
      getCollection("brandspot-collection").then((resp) => setBrandspotStories(resp));
    } else {
      setBrandspotStories([]);
    }
  }, []);

  brandspotStories[0] && stories.splice(4, 0, brandspotStories[0]);
  brandspotStories[1] && stories.splice(9, 0, brandspotStories[1]);

  const AdCard = ({ id, mobile }) => {
    return (
      <div styleName="ad-wrapper">
        <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
      </div>
    );
  };
  const renderFirstAd = useCallback(() => {
    return (
      <div styleName="ad-wrapper">
        <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1675837369206-0" mobile="PV_MWeb_HP_Top" />
      </div>
    );
  }, []);
  const firstStory = stories.splice(0, 1);
  const secondSetStories = stories.splice(0, 3);
  const thirdSetStories = stories.splice(0, 3);
  const restOfStories = stories;

  return (
    <>
      <div styleName="wrapper">
        <div styleName="firstStory-wrapper">
          {firstStory.map((item, index) => (
            <React.Fragment key={index}>
              <MobileStoryCard1 story={item} key={index} />
              {index === 0 && renderFirstAd()}
            </React.Fragment>
          ))}
        </div>

        <div className="secondSetStories-wrapper">
          {secondSetStories.map((item, index) => (
            <StoryCard3 story={item} key={index} index={index} />
          ))}
          {secondSetStories.length ? <AdCard id="div-gpt-ad-1675837402097-0" mobile="PV_MWeb_HP_Mid" /> : null}
        </div>

        <div className="thirdSetStories-wrapper">
          {thirdSetStories.map((item, index) => (
            <StoryCard3 story={item} key={index} index={index} />
          ))}
          {thirdSetStories.length ? <AdCard id="div-gpt-ad-1675837430268-0" mobile="PV_MWeb_HP_Bottom" /> : null}
        </div>

        <div className="restOfStories-wrapper">
          {restOfStories.slice(0, 9).map((item, index) => (
            <StoryCard3 story={item} key={index} />
          ))}
        </div>
        {subashithaStory && (
          <div styleName="subashitha-card">
            <Link href={`/${subashithaStory.slug}`}>
              <CardImage story={subashithaStory} aspectRatio={[16, 9]} imageType="image16x9" widths={[400]} />
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default MobileCollection;
